import React from "react";
import settlecardImg from "../../../styles/img/card-pos.png";

export const SettleCardIcon = () => {
  return (
    <>
      <img className="df-w-42" src={settlecardImg} />
    </>
  );
};
